import { PATH_INSPECTOR_DETAIL_TAB } from 'components/DeviceView/deviceViewConstants';
import {
  type DeviceViewEntityId,
  isNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import { getSelectedTable } from 'components/DeviceView/helpers/getSelectedTable';
import { isDeviceViewNodeStructure } from 'components/DeviceView/helpers/isDeviceViewNodeStructure';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import { highlightEdges } from 'components/Graph/commands/pathLookup/highlightEdges';
import { unhighlightEdges } from 'components/Graph/commands/pathLookup/unhighlightEdges';
import { EDGE_HIGHLIGHT_COLOR } from 'components/Graph/constants';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getNodeHighlightedEdges } from './helpers/getNodeHighlightedEdges';

export interface ChangePathLookupPathInspectorActiveNodeCommand {
  deviceViewEntityId: DeviceViewEntityId | null;
}

export const changePathLookupPathInspectorActiveNode: GraphCommandFactory<
  ChangePathLookupPathInspectorActiveNodeCommand
> = (cmdContext, dispatch) => (command) => {
  const deviceViewEntity = cmdContext
    .getDeviceView()
    .deviceViewEntities.find(
      (entity) => entity.id === command.deviceViewEntityId,
    );
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
  cmdContext.updateState((draft) => {
    const { highlightedEdges, activeNodeSn, selectedPackets } =
      draft.pathlookup.pathInspector;
    if (
      !isPathLookupGraphMetadata(draft.graphMetadata) ||
      Object.keys(selectedPackets).length === 0 ||
      (isDeviceViewNodeStructure(command) &&
        isNodeEntity(deviceViewEntity) &&
        deviceViewEntity.sn === activeNodeSn)
    ) {
      return;
    }

    const currentHighlightedEdges = getNodeHighlightedEdges(
      activeNodeSn,
      highlightedEdges,
    );
    if (currentHighlightedEdges !== undefined) {
      dispatch(unhighlightEdges, {
        color: true,
        edges: [
          ...currentHighlightedEdges.incomingEdges,
          ...currentHighlightedEdges.outgoingEdges,
        ],
      });
    }

    if (isNodeEntity(deviceViewEntity)) {
      draft.pathlookup.pathInspector.activeNodeSn = deviceViewEntity.sn;

      const nodeHighlightedEdges =
        draft.pathlookup.pathInspector.highlightedEdges[deviceViewEntity.sn];
      if (!nodeHighlightedEdges) {
        return;
      }

      // Highlight edges only if path inspector tab is active
      const selectedTable = getSelectedTable(
        deviceViewEntity,
        cmdContext.getDeviceView().settings,
        cmdContext.getDeviceView().pathsWithName,
        null,
      );
      if (selectedTable === PATH_INSPECTOR_DETAIL_TAB) {
        dispatch(highlightEdges, {
          color: EDGE_HIGHLIGHT_COLOR,
          edges: [
            ...nodeHighlightedEdges.incomingEdges,
            ...nodeHighlightedEdges.outgoingEdges,
          ],
        });
      }
    } else {
      draft.pathlookup.pathInspector.activeNodeSn = null;
    }
  });
};
